export const CHECKOUT = 'CHECKOUT';
export const CHECKOUT_ADD_SHOPPER_DETAILS = `${CHECKOUT}/ADD_SHOPPER_DETAILS`;
export const CHECKOUT_GET_SHOPPER_DETAILS = `${CHECKOUT}/GET_SHOPPER_DETAILS`;
export const CHECKOUT_GET_VERIFICATION_CODE = `${CHECKOUT}/GET_VERIFICATION_CODE`;
export const CHECKOUT_VALIDATE_VERIFICATION_CODE = `${CHECKOUT}/VALIDATE_VERIFICATION_CODE`;
export const CHECKOUT_ADD_DELIVERY_ADDRESS = `${CHECKOUT}/ADD_DELIVERY_ADDRESS`;
export const CHECKOUT_GET_DELIVERY_ADDRESS = `${CHECKOUT}/GET_DELIVERY_ADDRESS`;
export const CHECKOUT_CHANGE_SHOPPER = `${CHECKOUT}/CHANGE_SHOPPER`;
export const CHECKOUT_PAYMENT_METHODS = `${CHECKOUT}/PAYMENT_METHODS`;
export const CHECKOUT_ORDER_CREATE = `${CHECKOUT}/ORDER_CREATE`;
export const CHECKOUT_PREVIEW_STRIPE_TERMINAL_ORDER = `${CHECKOUT}/PREVIEW_STRIPE_TERMINAL_ORDER`;
